import * as React from 'react';
import { forwardRef } from 'react';
const Kbc = (props, ref) => {
    const prefixId = React.useId();
    return (React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("g", { clipPath: `url(#$${prefixId}__clip0_2180_1107)` },
            React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#00ACEF" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.689 22.002c.86.528 1.912.846 3.084.846 1.222 0 2.397-.561 3.275-1.43l9.452-.87v4.6h-25v-2.3l9.189-.846Zm3.88-1.454c-2.197 0-3.978-1.801-3.978-4.024 0-2.222 1.78-4.024 3.977-4.024s3.977 1.802 3.977 4.024c0 2.223-1.78 4.024-3.977 4.024Z", fill: "#fff" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: `$${prefixId}__clip0_2180_1107` },
                React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#fff" })))));
};
const ForwardRef = forwardRef(Kbc);
export default ForwardRef;
ForwardRef.displayName = 'Kbc';
//# sourceMappingURL=Kbc.js.map